import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

interface TransactionPadProps {
  // A assinatura da prop foi corrigida para corresponder à função no componente pai
  onTransactionRequest: (valor: number, numeroComanda: string) => void;
  onClear: boolean;
}

const TransactionPad: React.FC<TransactionPadProps> = ({ onTransactionRequest, onClear }) => {
  const [displayValue, setDisplayValue] = useState<string>('0,00');
  const [numeroComanda, setNumeroComanda] = useState<string>(''); // Novo estado para o número da comanda

  const handleNumberPadClick = (button: string) => {
    if (button === 'Del') {
      setDisplayValue(prev => {
        const rawValue = prev.replace(',', '');
        const newValue = rawValue.slice(0, -1);
        if (newValue.length === 0) return '0,00';
        if (newValue.length <= 2) return `0,${newValue.padStart(2, '0')}`;
        return `${newValue.slice(0, -2)},${newValue.slice(-2)}`;
      });
      return;
    }

    setDisplayValue(prev => {
      const rawValue = prev.replace(',', '');
      const newValue = rawValue + button;
      const parsedValue = parseInt(newValue, 10).toString(); // Remove zeros à esquerda
      if (parsedValue.length <= 2) return `0,${parsedValue.padStart(2, '0')}`;
      return `${parsedValue.slice(0, -2)},${parsedValue.slice(-2)}`;
    });
  };

  const handleClear = () => {
    setDisplayValue('0,00');
    setNumeroComanda(''); // Limpa a comanda também
  };

  const handleTransaction = () => {
    const valorNumerico = parseFloat(displayValue.replace(',', '.'));
    if (valorNumerico <= 0) {
      // Idealmente, o botão estaria desabilitado, mas é uma segurança extra.
      return;
    }
    // Chama a função com os dois argumentos corretos
    onTransactionRequest(valorNumerico, numeroComanda);
  };

  useEffect(() => {
    if(onClear){
      handleClear();
    }
  }, [onClear]);

  const padButtons = [
    '1', '2', '3',
    '4', '5', '6',
    '7', '8', '9',
    ',', '0', 'Del',
  ];

  return (
    <div className="flex flex-col gap-4">
      {/* Campo de Input para o Número da Comanda */}
      <div className="mb-2">
        <label htmlFor="comanda-input" className="block text-sm font-medium text-text-secondary mb-1">
          Número da Comanda (Opcional)
        </label>
        <Input
          id="comanda-input"
          tipo="text"
          placeholder="Ex: 12345"
          value={numeroComanda}
          onChange={(e) => setNumeroComanda(e.target.value)}
          className="w-full bg-gradient-to-r from-[#c5a663] via-[#cebc6e] to-[#c5a663]  border border-primary/20 rounded-lg"
        />
      </div>

      {/* Display do Valor */}
      <div className="bg-gradient-to-r from-[#c5a663] via-[#cebc6e] to-[#c5a663]  text-white text-4xl font-mono text-right p-4 rounded-lg">
        R$ {displayValue}
      </div>

      {/* Teclado Numérico */}
      <div className="grid grid-cols-3 gap-3 mb-2 flex-grow">
        {padButtons.map((button, index) => (
          <motion.div key={index} whileTap={{ scale: 0.95 }} className={button === '0' ? 'col-span-2' : ''}>
            <Button
              onClick={() => handleNumberPadClick(button)}
              className={`w-full h-16 text-2xl font-semibold rounded-lg transition-all duration-200 
                ${button === 'Del' ? 'bg-danger hover:bg-red-700' : 'bg-gradient-to-r from-[#c5a663] via-[#cebc6e] to-[#c5a663]  hover:bg-gray-600'} text-white`}
            >
              {button}
            </Button>
          </motion.div>
        ))}
      </div>

      {/* Botões de Ação */}
      <div className="flex gap-4 mt-2">
        <Button
          onClick={handleClear}
          className="w-1/2 h-14 text-xl font-bold bg-gray-600 hover:bg-gray-500 text-text rounded-lg shadow-md transition-all duration-200"
        >
          Limpar
        </Button>
        <motion.div whileTap={{ scale: 0.95 }} className="w-1/2">
          <Button
            onClick={handleTransaction}
            className="w-full h-14 text-xl font-bold bg-gradient-to-r from-[#c5a663] via-[#cebc6e] to-[#c5a663]  hover:bg-gradient-to-r from-[#c5a663] via-[#f2dd82] to-[#c5a663]/80 text-white rounded-lg shadow-md transition-all duration-200"
            disabled={parseFloat(displayValue.replace(',', '.')) <= 0}
          >
            Gerar QR Code
          </Button>
        </motion.div>
      </div>
    </div>
  );
};

export default TransactionPad;